/**
 * Origem Flow: modelos de projeto por tipo de cliente (loja × prefeitura).
 */
export default (client) => {
  return {
    list() {
      return client.get('/client-templates/')
    },
    apply(tableId, template) {
      return client.post(`/client-templates/table/${tableId}/apply/`, {
        template,
      })
    },
  }
}
